import React, { useEffect, useState } from "react";
import {
  Layout,
  Space,
  PageHeader,
  message
} from "antd";
import R2Footer from "../../../components/Footer";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import "./style.scss";
import EmployeeService from "../../../services/EmployeeService"; 
import InviteCard from "./childrens/inviteCard";

const { Content } = Layout;

const Invite = (props) => {
  const [invitationReq, setInvitationReq] = useState({});
  const [employeType, setEmployeType] = useState([]);

  const getAllRoles = () => {
    const restaurant_id = props.adminRestaurant;
    EmployeeService.getEmployeType(restaurant_id).then((res)=>{
      setEmployeType(res);
    });
  };

  useEffect(()=>{
    getAllRoles();
  },[props.adminRestaurant]);

  const onSendInvite = () => {
    const reqData = {...invitationReq};
    reqData.restaurant_id = props.adminRestaurant;
    if(!invitationReq.name || !invitationReq.email ||
      !invitationReq.phone_number || !invitationReq.employee_type_id  ) {
        message.warning('Please fill all the fields')
    } else {
      EmployeeService.sendInvite(reqData).then((res)=>{
        if(res){
          message.success("Invite send successfully");
          setInvitationReq({});
        }
      }).catch((e)=>{
        message.error(e?.response?.data?.msg);
      });
  }
  };
  return (
    <Layout className="u-page-layout">
      <Content className="mem__setting_ui page-padding">
        <Space
          direction="vertical"
          style={{
            width: "100%",
          }}
        >
          <PageHeader className="page-header" title="Invite Employee" style={{ background: "#f0f2f5" }} />
          <div>
            <InviteCard 
                setInvitationReq={setInvitationReq}
                invitationReq={invitationReq}
                onSendInvite={onSendInvite}
                employeType={employeType}
             />
          </div>
        </Space>
      </Content>
      <R2Footer />
    </Layout>
  );
};

const mapStateToProps = (state) => {
  return {
    adminRestaurant: state.admin,
  };
};
export default withRouter(connect(mapStateToProps)(Invite));
